import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import "core-js/modules/es.object.to-string.js";
import * as React from 'react';
import cn from 'classnames';
import styles from '../input.p.module.css.js';

function transferInteractiveProps(iconProps) {
  var _context;

  var props = ['onClick', 'onContextMenu', 'onDoubleClick', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', 'aria-label'];

  var button = _filterInstanceProperty(_context = _Object$keys(iconProps)).call(_context, function (key) {
    return props.indexOf(key) > -1;
  }).reduce(function (obj, key) {
    return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, key, iconProps[key]));
  }, {});

  var icon = _Object$keys(button).reduce(function (obj, key) {
    return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, key, null));
  }, {});

  return {
    button: button,
    icon: icon
  };
}

var CustomIcon = function CustomIcon(_ref) {
  var icon = _ref.icon,
      size = _ref.size,
      iconPosition = _ref.iconPosition,
      iconIsAction = _ref.iconIsAction,
      iconIsFocusable = _ref.iconIsFocusable;
  var mouseEvents = transferInteractiveProps(icon.props);
  var iconJsx = /*#__PURE__*/React.cloneElement(icon, _objectSpread({
    size: size,
    focusable: false
  }, mouseEvents.icon));
  return /*#__PURE__*/React.createElement("span", _objectSpread(_objectSpread({
    role: iconIsAction ? 'button' : null,
    key: "icon",
    className: cn(styles.icon, styles[iconPosition], iconIsAction && styles.action)
  }, mouseEvents.button), {}, {
    "data-test": "input__icon",
    tabIndex: iconIsAction && iconIsFocusable ? 0 : -1
  }), iconJsx);
};

export { CustomIcon, transferInteractiveProps };
